import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function ProfessionList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasProfAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasProfEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const [searchParams] = useSearchParams();

  const columns = [
    { field: "PI_Id", label: "#" },
    { field: "PI_Name", label: "Profession" },
    { field: "PI_Status", label: "Status" },
  ];

  const actions = [
    hasProfEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.PI_Id));
        navigate(
          `/ProfessionLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean); // Remove falsy values if privilege check fails

  return (
   <DynamicTable
      columns={columns}
      dataAPI={`/Profession/list`}
      actions={actions}
      title="Profession"
      {...(hasProfAddprivilege(privilegeData) && {
        linkvalue: `/ProfessionLookup/Add?${searchParams.toString()}`
      })}
    />
  );
}

export default ProfessionList;
